<template>
  <ViewWrapper
    class="personal_dashboard"
    :scrollable="true"
    @close="$router.replace({ name: 'companyDetail' })"
  >
    <DashboardSummary />
    <DashboardKpiOverview />

    <ButtonPill class="personal_dashboard__back-to-globe" :to="{ name: 'companyDetail' }" replace>
      {{ $t('view.personalDashboard.backToGlobe') }}
    </ButtonPill>
  </ViewWrapper>
</template>

<script>
import ButtonPill from '../components/ButtonPill';
import DashboardSummary from '../components/Dashboard/Summary';
import DashboardKpiOverview from '../components/Dashboard/KpiOverview';
import ViewWrapper from '../components/ViewWrapper';

export default {
  name: 'PersonalDashboard',

  components: {
    ButtonPill,
    DashboardSummary,
    DashboardKpiOverview,
    ViewWrapper,
  },
};
</script>

<style lang="scss" scoped>
.personal_dashboard {
  background-color: rgba($color-background, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-background);
  overflow-x: hidden;
}

.personal_dashboard__back-to-globe {
  width: 240px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: calc(20px + env(safe-area-inset-bottom));
}
</style>
